import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/common/DriverCustom.css"; // Tutorial (driver.js) popovers, used on every page
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import RootLayout from "./layouts/root-layout";
import IndexPage from "./routes";
import SignInPage from "./routes/sign-in";
import DashboardLayout from "./layouts/dashboard-layout";
import Livestreaming from "./routes/livestreaming";
import Detections from "./routes/detection";
import FinancialTracker from "./routes/financialTracker";
import Dashboard from "./routes/dashboard";
import DashboardVictron from "./routes/dashboard-v2";
import NavLayout from "./layouts/nav-layout";
import DeviceManager from "./routes/deviceManager";
import OrgSelector from "./layouts/orgselector-layout";
import RouteError from "./components/common/RouteError";
import ErrorBoundary from "./components/common/ErrorBoundary";

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteError fullHeight />,
    children: [
      { path: "/sign-in/*", element: <SignInPage /> },
      { path: "/org-selector", element: <OrgSelector /> },
      {
        element: <OrgSelector />,
        path: "",
      },
      {
        element: <NavLayout />,
        path: "/",
        errorElement: <RouteError />,
        children: [
          { path: "/index", element: <IndexPage /> },
          { path: "/livestreaming/*", element: <Livestreaming /> },
          { path: "/detection/*", element: <Detections /> },
          { path: "/financialtracker/*", element: <FinancialTracker /> },
          { path: "/devicemanager/*", element: <DeviceManager /> },
          {
            element: <DashboardLayout />,
            errorElement: <RouteError />,
            children: [
              { path: "/dashboard", element: <Dashboard /> },
              { path: "/dashboard-v2", element: <DashboardVictron /> },
            ],
          },
        ],
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
